import API from '../';
import { HTTP_METHODS } from '../helpers/methods-helpers';

class UsersAPI extends API {
	getByOrgan(organ, pagination, currentPage) {
		const paginationUrl = pagination
			? `&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/consulta?organo=${organ}${paginationUrl}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	getUsersByOrgan(organ) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/consulta?organo=${organ}&conOrganos=false`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	getFilterConsult(status, start_date, end_date, pagination, currentPage) {
		const paginationUrl = pagination
			? `&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/get?estatus=${status}&fechaInicio=${start_date}&fechaFin=${end_date}&conorganos=false${paginationUrl}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	getFilterAccess() {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/accesos`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	getFilterAccessLog({
		user,
		status,
		start_date,
		end_date,
		nick,
		pagination,
		currentPage,
	}) {
		let url = `${
			this.scheme
		}/filtros?estatus=${status}&sigPagina=${currentPage}&paginacion=${pagination}&idUsuario=${
			user || ''
		}&usuario=${nick || ''}`;

		if (start_date && end_date) {
			url += `&fechainicio=${start_date.toLocaleDateString(
				'en-GB'
			)}&fechafin=${end_date.toLocaleDateString('en-GB')}`;
		} else {
			url += `&fechainicio=&fechafin=`;
		}

		//Cambiar nick por campo del back

		return this.requestWrapper(
			this.request({
				url: url,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getFilterAccessLogSegurity({
		user,
		status,
		start_date,
		end_date,
		inUsuarioAfectado,
		nick,
		pagination,
		currentPage,
	}) {
		let url = `${this.scheme}/filtros?estatus=${status}&inUsuarioAfectado=${inUsuarioAfectado}&paginacion=${pagination}`;
		if (start_date && end_date) {
			url += `&fechainicio=${start_date.toLocaleDateString(
				'en-GB'
			)}&fechafin=${end_date.toLocaleDateString('en-GB')}&sigPagina=${currentPage}`;
		} else {
			url += `&fechainicio=&fechafin=&sigPagina=${currentPage}`;
		}
		//Cambiar nick por campo del back

		if (nick) {
			url += `&usuario=${nick}`;
		}
		if (user) {
			url += `&idUsuario=${user}`;
		}
		return this.requestWrapper(
			this.request({
				url: url,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getByInstitution(institution, pagination, currentPage) {
		const paginationUrl = pagination
			? `&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/institucion/consulta?institucion=${institution}${paginationUrl}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getByOrganInstitution(organ, institution, pagination, currentPage) {
		const paginationUrl = pagination
			? `&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/organo/institucion/consulta?organo=${organ}&institucion=${institution}${paginationUrl}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getByOrganSeveralInstitution(organoId, institucionesId) {
		let payload = organoId ? { organoId, institucionesId } : { institucionesId };
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/seguimiento/instituciones`,
				data: JSON.stringify(payload),
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getBySector(sector, pagination, currentPage) {
		const paginationUrl = pagination
			? `&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/sector/consulta?sector=${sector}${paginationUrl}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getByOrganSector(organ, sector, pagination, currentPage) {
		const paginationUrl = pagination
			? `&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/organo/sector/consulta?organo=${organ}&sector=${sector}${paginationUrl}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getBySectorUnit(sector, unit, pagination, currentPage) {
		const paginationUrl = pagination
			? `&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/sector/unidad_administrativa/consulta?sector=${sector}&unidad=${unit}${paginationUrl}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getByOrganSectorInstitution(organ, sector, institution, pagination, currentPage) {
		const paginationUrl = pagination
			? `&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/organo/sector/unidad_administrativa/consulta?organo=${organ}&sector=${sector}&unidad=${institution}${paginationUrl}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getAllUsers() {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/todos`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getAllUsersStatus() {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/obtener/todos`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getpredictive(user, pagination, currentPage) {
		const paginationUrl = pagination
			? `&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/predictivo?nombre=${user}${paginationUrl}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	postChangePassword(data) {
		const dataString = JSON.stringify(data);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/actualiza_pass`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	postRecoverPassword(user) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/recuperar-pass/${user}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getUserIN(user) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/obtener-usuario-autentica/${user}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getUserEXT(user) {
		const dataString = JSON.stringify(user);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/obtener-is`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	postAssignOrgans(data) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/agregar-organos`,
				data: JSON.stringify(data),
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getAllUser(pagination, currentPage) {
		const dataString = JSON.stringify();
		const paginationUrl = pagination
			? `?registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/get${paginationUrl}`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getDirectory(pagination, currentPage, filters = {}) {
		const queryParams = ['informativo=true'];

		if (pagination) {
			queryParams.push(`registrosPorPagina=${pagination}`);
			queryParams.push(`numeroDePagina=${currentPage}`);
		}

		Object.entries(filters).forEach(([key, value]) => {
			if (value !== undefined && value !== null && value !== '') {
				queryParams.push(`${key}=${encodeURIComponent(value)}`);
			}
		});

		const queryString = `?${queryParams.join('&')}`;
		const dataString = JSON.stringify({});

		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/consulta${queryString}`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}

export const usersAPI = new UsersAPI('/usuarios');
